<template>
  <div v-html="info" class="detail-img" ref="detail"></div>
</template>
<script>
export default {
  props: {
    info: {
      type: String,
      default: ''
    }
  },
  async updated () {
    this.$nextTick(() => {
      let ssd = document.querySelector(".ssd-module-wrap");
      if (ssd) {
        setTimeout(() => {
          if (ssd.offsetWidth > document.body.offsetWidth) {
            ssd.style.width = document.body.clientWidth
            ssd.style.transform = `scale(${document.body.clientWidth / ssd.offsetWidth
              },0.5)`;
            ssd.style.transformOrigin = "0 0";
            this.$refs.detail.style.height =
              ssd.offsetHeight /
              Math.ceil(ssd.offsetWidth / document.body.clientWidth) +
              "px";
          }
        }, 500);
      }
    });
  }
}
</script>
<style lang="scss" scoped>
  .detail-img {
    margin-top: 0.8rem;
  }
</style>